module.exports = __webpack_public_path__ + "static/gradientTwo-39147d770098a3d79780d5852591ea44.svg";